import { setAllWidgets } from "../../../../app/api/manageWidgets";
import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { IManageWidgetItem } from "../../../../Orchestrator/Types/Interface/IWidgetsReqAndRes";


interface IManageWidgetDragAndDropParams {
    manageWidgets: IManageWidgetItem[];
}

class ManageWidgetDragAndDropAction extends BaseAction<void, IManageWidgetDragAndDropParams> {
    override async run(): Promise<void> {
        const { manageWidgets } = this.params!;

        try {
            const payload = manageWidgets.map((widget) => {
                return `${widget.valueKey}:${widget.value}`
            })
            const response: any = await setAllWidgets({ widgets: payload });
            if (response.status === "ok" && response.answer) {
                //updateRecoilState("manageWidgetsAtom", manageWidgets);
            }
        } catch (error: any) {
            console.error("Error updating widgets:", error);
        }
    }
}

export const manageWidgetDragAndDropAction = new ManageWidgetDragAndDropAction();
